'use client'

// React Imports
import { useMemo } from 'react'

// MUI Imports
import Grid from '@mui/material/Grid'

// Component Imports
import FollowUpListWrapper from './FollowUpListWrapper'

const FollowUpList = ({
    onAction,
    onViewDetail,
    onViewLead,
    onScorecardMouseEnter,
    onScorecardMouseLeave,
    // Add optimized props
    data,
    totalRecords,
    loading,
    isInitialLoad,
    currentPage,
    itemsPerPage,
    onPageChange,
    stats,
    crmOperationPerms,
    // Other common props
    filters,
    handleStatusFilter,
    handleShowAll,
    searchTerm,
    setSearchTerm,
    viewMode,
    setViewMode,
    onExport,
    onCustomDownload,
    isHiddenField = () => false
}) => {
    return (
        <FollowUpListWrapper
            onAction={onAction}
            onViewDetail={onViewDetail}
            onViewLead={onViewLead}
            onScorecardMouseEnter={onScorecardMouseEnter}
            onScorecardMouseLeave={onScorecardMouseLeave}
            // Pass through optimized props
            data={data}
            totalRecords={totalRecords}
            loading={loading}
            isInitialLoad={isInitialLoad}
            currentPage={currentPage}
            itemsPerPage={itemsPerPage}
            onPageChange={onPageChange}
            stats={stats}
            crmOperationPerms={crmOperationPerms}
            // Other common props
            filters={filters}
            handleStatusFilter={handleStatusFilter}
            handleShowAll={handleShowAll}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            viewMode={viewMode}
            setViewMode={setViewMode}
            onExport={onExport}
            onCustomDownload={onCustomDownload}
            isHiddenField={isHiddenField}
        />
    )
}

export default FollowUpList
